import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { useState, useCallback, useEffect } from 'react';
import { RequestStatus } from '@lib/plugin-redux-core';
import { useDispatch, useSelector } from 'react-redux';
import { getUseCase } from '@lib/plugin-redux-core';
import { CREATE_FILE_STORAGE_V2_USE_CASE, UPLOAD_FILE_V2_USE_CASE, DELETE_FILE_V2_USE_CASE, FileResourceType } from '../../../../file-storage';
import { createFileStorageV2StatusSelector, createFileStorageV2OutputSelector, uploadFileV2StatusSelector } from '../../redux/file-storage';
import { AttachmentFileType } from '../../types/file-management.types';
import { AI_CHAT_MAX_TOTAL_FILE_SIZE_BYTES } from '../../config/ai-chat-file-constraints';

var isSameFile = function isSameFile(a, b) {
  return a.name === b.name && a.size === b.size && a.lastModified === b.lastModified && a.type === b.type;
};

var determineFileType = function determineFileType(file) {
  var _file$name$split$pop;

  var extension = (_file$name$split$pop = file.name.split('.').pop()) === null || _file$name$split$pop === void 0 ? void 0 : _file$name$split$pop.toLowerCase();

  switch (extension) {
    case 'pdf':
      return AttachmentFileType.PDF_DOCUMENT;

    case 'doc':
    case 'docx':
      return AttachmentFileType.WORD_DOCUMENT;

    case 'xls':
    case 'xlsx':
    case 'csv':
      return AttachmentFileType.SPREADSHEET;

    case 'jpg':
    case 'jpeg':
    case 'png':
    case 'gif':
    case 'bmp':
    case 'svg':
    case 'webp':
      return AttachmentFileType.IMAGE;

    default:
      return AttachmentFileType.FILE;
  }
};

export var useUploadFiles = function useUploadFiles(maxFileUpload) {
  var _useState = useState([]),
      files = _useState[0],
      setFiles = _useState[1];

  var _useState2 = useState(null),
      error = _useState2[0],
      setError = _useState2[1];

  var _useState3 = useState(0),
      uploadProgress = _useState3[0],
      setUploadProgress = _useState3[1];

  var _useState4 = useState(null),
      validatingUrl = _useState4[0],
      setValidatingUrl = _useState4[1];

  var _useState5 = useState([]),
      pendingFiles = _useState5[0],
      setPendingFiles = _useState5[1];

  var dispatch = useDispatch(); // Get status from Redux

  var uploadFileV2Status = useSelector(uploadFileV2StatusSelector);
  var createFileStorageV2Status = useSelector(createFileStorageV2StatusSelector);
  var createFileStorageV2Output = useSelector(createFileStorageV2OutputSelector);
  var isUploading = uploadFileV2Status === RequestStatus.EXECUTE;
  var isValidating = createFileStorageV2Status === RequestStatus.EXECUTE; // Computed value to check if there are successfully uploaded files

  var hasUploadedFiles = files.some(function (file) {
    return file.uploadUrl && file.storageId && !file.isLoading;
  });
  var resetCreateFileStorageState = useCallback(function () {
    var createFileStorageV2UseCase = getUseCase(CREATE_FILE_STORAGE_V2_USE_CASE, dispatch);
    createFileStorageV2UseCase.reset();
  }, [dispatch]); // The storage-create use case exposes one Redux result at a time. Queue local files so a
  // multi-file selection cannot overwrite another file's presigned-upload response.

  useEffect(function () {
    if (createFileStorageV2Status === RequestStatus.EXECUTE || validatingUrl || pendingFiles.length === 0) {
      return;
    }

    var nextFile = pendingFiles[0];
    setValidatingUrl(nextFile.name);
    getUseCase(CREATE_FILE_STORAGE_V2_USE_CASE, dispatch).execute({
      fileName: nextFile.name,
      size: nextFile.size,
      mimeType: nextFile.type,
      resourceType: FileResourceType.Document,
      usageType: 'ai_chat_attachment',
      metadata: {
        sourceApp: 'ai-chat-app'
      }
    });
  }, [createFileStorageV2Status, dispatch, pendingFiles, validatingUrl]); // Monitor createFileStorageV2 success and update local state

  useEffect(function () {
    if (createFileStorageV2Status === RequestStatus.SUCCESS && createFileStorageV2Output) {
      var matchedFile = pendingFiles[0];

      if (matchedFile) {
        setFiles(function (prev) {
          var newFile = {
            file: matchedFile,
            id: createFileStorageV2Output.id,
            url: createFileStorageV2Output.url,
            uploadUrl: createFileStorageV2Output.uploadUrl,
            storageId: createFileStorageV2Output.id,
            isLoading: false
          }; // Check if already exists

          var exists = prev.some(function (f) {
            return f.id === newFile.id;
          });

          if (!exists) {
            return [].concat(_toConsumableArray(prev), [newFile]);
          }

          return prev;
        }); // Remove the matched file from pendingFiles

        setPendingFiles(function (prev) {
          return prev.filter(function (f) {
            return f !== matchedFile;
          });
        });
      } // Clear the validating URL


      setValidatingUrl(null);
      resetCreateFileStorageState();
    } else if (createFileStorageV2Status === RequestStatus.ERROR) {
      setPendingFiles(function (prev) {
        return prev.slice(1);
      });
      setValidatingUrl(null);
      resetCreateFileStorageState();
    }
  }, [createFileStorageV2Status, createFileStorageV2Output, pendingFiles, validatingUrl, resetCreateFileStorageState]);
  var addFiles = useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(rawFiles) {
      var totalSize, _iterator, _step, _loop, _ret;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              setError(null);
              totalSize = [].concat(_toConsumableArray(files.map(function (file) {
                return file.file;
              })), _toConsumableArray(pendingFiles)).reduce(function (total, file) {
                return total + file.size;
              }, 0);
              _iterator = _createForOfIteratorHelper(rawFiles);
              _context.prev = 4;

              _loop = function _loop() {
                var rawFile = _step.value;
                // Check for duplicates
                var exists = files.some(function (f) {
                  return isSameFile(f.file, rawFile);
                });

                if (exists) {
                  return "continue";
                }

                if (maxFileUpload && files.length >= maxFileUpload) {
                  setError("You can only upload up to ".concat(maxFileUpload, " file(s)"));
                  return {
                    v: void 0
                  };
                }

                totalSize += rawFile.size;

                if (totalSize >= AI_CHAT_MAX_TOTAL_FILE_SIZE_BYTES) {
                  setError('The combined size of selected files must be smaller than 50 MB.');
                  return {
                    v: void 0
                  };
                } // Queue the file. The effect above creates storage entries sequentially.


                setPendingFiles(function (prev) {
                  return [].concat(_toConsumableArray(prev), [rawFile]);
                });
              };

              _iterator.s();

            case 7:
              if ((_step = _iterator.n()).done) {
                _context.next = 15;
                break;
              }

              _ret = _loop();

              if (!(_ret === "continue")) {
                _context.next = 11;
                break;
              }

              return _context.abrupt("continue", 13);

            case 11:
              if (!(typeof _ret === "object")) {
                _context.next = 13;
                break;
              }

              return _context.abrupt("return", _ret.v);

            case 13:
              _context.next = 7;
              break;

            case 15:
              _context.next = 20;
              break;

            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](4);

              _iterator.e(_context.t0);

            case 20:
              _context.prev = 20;

              _iterator.f();

              return _context.finish(20);

            case 23:
              _context.next = 29;
              break;

            case 25:
              _context.prev = 25;
              _context.t1 = _context["catch"](0);
              setError((_context.t1 === null || _context.t1 === void 0 ? void 0 : _context.t1.message) || 'Failed to process files');
              setValidatingUrl(null);

            case 29:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 25], [4, 17, 20, 23]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [files, maxFileUpload, pendingFiles]);
  var removeFile = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(fileId) {
      var deleteFileV2Input, deleteFileV2UseCase;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              try {
                setError(null);
                deleteFileV2Input = {
                  id: fileId
                };
                deleteFileV2UseCase = getUseCase(DELETE_FILE_V2_USE_CASE, dispatch);
                deleteFileV2UseCase.execute(deleteFileV2Input); // Update local state

                setFiles(function (prev) {
                  return prev.filter(function (file) {
                    return file.id !== fileId;
                  });
                });
              } catch (err) {
                setError((err === null || err === void 0 ? void 0 : err.message) || 'Failed to delete file');
              }

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }(), []); // 3. UPLOAD_FILE_V2_USE_CASE integration

  var uploadFiles = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var uploadedItems, i, file, uploadFileV2Input, uploadFileV2UseCase, fileType, attachmentItem;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            setError(null);
            setUploadProgress(0);
            uploadedItems = [];
            i = 0;

          case 5:
            if (!(i < files.length)) {
              _context3.next = 19;
              break;
            }

            file = files[i];

            if (!(!file.uploadUrl || !file.storageId)) {
              _context3.next = 9;
              break;
            }

            throw new Error("Storage not ready for file: ".concat(file.file.name));

          case 9:
            // Fake progress
            setUploadProgress(i / files.length * 80); // Call UPLOAD_FILE_V2_USE_CASE

            uploadFileV2Input = {
              uploadUrl: file.uploadUrl,
              file: file.file
            };
            uploadFileV2UseCase = getUseCase(UPLOAD_FILE_V2_USE_CASE, dispatch);
            uploadFileV2UseCase.execute(uploadFileV2Input); // Create attachment item for successful upload

            fileType = determineFileType(file.file);
            attachmentItem = {
              id: file.storageId,
              name: file.file.name,
              url: file.url,
              fileType: fileType,
              size: file.file.size,
              type: 'LOCAL_FILE'
            };
            uploadedItems.push(attachmentItem);

          case 16:
            i++;
            _context3.next = 5;
            break;

          case 19:
            // Complete progress
            setUploadProgress(100);
            return _context3.abrupt("return", uploadedItems);

          case 23:
            _context3.prev = 23;
            _context3.t0 = _context3["catch"](0);
            setError((_context3.t0 === null || _context3.t0 === void 0 ? void 0 : _context3.t0.message) || 'Failed to upload files');
            setUploadProgress(0);
            throw _context3.t0;

          case 28:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 23]]);
  })), [files, createFileStorageV2Output]);
  var clearFiles = useCallback(function () {
    resetCreateFileStorageState();
    setFiles([]);
    setError(null);
    setUploadProgress(0);
    setValidatingUrl(null);
    setPendingFiles([]);
  }, [resetCreateFileStorageState]);
  useEffect(function () {
    return function () {
      resetCreateFileStorageState();
    };
  }, [resetCreateFileStorageState]);
  var onFilesSelected = useCallback(function (fileList) {
    var array = Array.from(fileList);
    addFiles(array);
  }, [addFiles]);
  return {
    files: files,
    isUploading: isUploading,
    isValidating: isValidating,
    error: error,
    uploadProgress: uploadProgress,
    hasUploadedFiles: hasUploadedFiles,
    validatingUrl: validatingUrl,
    addFiles: addFiles,
    removeFile: removeFile,
    uploadFiles: uploadFiles,
    clearFiles: clearFiles,
    onFilesSelected: onFilesSelected
  };
};